import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormArray } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { EmbryoService } from 'src/app/Services/Embryo.service';
import { StaticPagesService } from 'src/app/Services/static-pages.service';

@Component({
  selector: 'app-order-rate',
  templateUrl: './order-rate.component.html',
  styleUrls: ['./order-rate.component.scss']
})
export class OrderRateComponent implements OnInit {

  addAddressForm!: FormGroup;
  cities: any;
  user: any;
  areaList: any;
  typeAddess: any;
  rateForm!: FormGroup;
  routerId!:number;
  submittingRate:boolean = false;
  skipingRate:boolean = false;
  lang: any  = 'en';
  environmentVariables: any;
  constructor(private formBuilder: FormBuilder, public dialog: MatDialog, public dialogRef: MatDialogRef<OrderRateComponent>,
    public snackBar: MatSnackBar, 
    @Inject(MAT_DIALOG_DATA ) public data : any, 
     private embryoService: EmbryoService,
     private confgServ: StaticPagesService,

    ) { 
    }

  ngOnInit() {
    this.lang = localStorage.getItem("lang");

  //  this.route.params.subscribe(params => {
  //   this.routerId = params['id']
  // });
  // console.log(this.orderId);
  this.confgServ.getenvConfig().subscribe((res) => {
    this.environmentVariables = res;
});  

    this.rateForm = new FormGroup({
      rate: new FormControl(this.data.rate ? this.data.rate :'' , Validators.required),
      driver_rate: new FormControl(this.data.driver_rate ?this.data.driver_rate:'' , Validators.required),
      items:this.formBuilder.array([]), 
      feedback: new FormControl(this.data.feedback? this.data.feedback: '')
    });
    this.data.items.forEach((element:any) => {
      this.addItem(element);
    });
  }
  get formItems() {
    return (this.rateForm.get('items') as FormArray).controls;
  }

  addItem(product:any) {
    const item = this.formBuilder.group({
      name:this.lang ==='en' ? product.name : product.name_ar,
      rate: 0,
      image:product.image ?? "",
      id:product.id
    });

    (this.rateForm.get('items') as FormArray).push(item);
  }
  submitRate() {

    if (!this.rateForm.valid) {
      this.markFormGroupTouched(this.rateForm);
      return;
    }
     this.rateForm.value['is_skip'] = false;
     this.submittingRate = true;
    //  ? this.data.id : this.data
    this.embryoService.RateOrderAndDriver(this.rateForm.value , this.data.id).subscribe((response: any) => {
        this.submittingRate = false;
      if (response.code == 200) {
        this.data.rate = response.data.rate;
        this.data.driver_rate = response.data.driver_rate;
        this.data.feedback = response.data.feedback;
        this.embryoService.sendRateData(response.data)
        this.dialogRef.close(response.data);
      }
    });
  }

  skip()  {
      this.rateForm.value['is_skip'] = true;
      this.rateForm.value['rate'] = null;
      this.rateForm.value['driver_rate'] = null;
      this.rateForm.value['feedback'] = null;
      this.skipingRate = true;
      // ? this.data.id : this.data
    this.embryoService.RateOrderAndDriver(this.rateForm.value  , this.data.id ).subscribe((response: any) => {
     this.skipingRate =  false;
      if (response.code == 200) {
        this.dialogRef.close(response.data);
      }
    });
  }

  close(){
    this.dialogRef.close();
  }


  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach((control : any) => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }
}
